module.exports = "<div class=\"issue-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>"